import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-coupon-applied-popup',
  templateUrl: './coupon-applied-popup.component.html',
  styleUrls: ['./coupon-applied-popup.component.scss']
})
export class CouponAppliedPopupComponent implements OnInit {
  @Input() couponData: any = "";
  @Input() isDiwaliSale = false;
  @Input() isShowAppliedButton: boolean = false;
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
  }

  closeByDeviceType() {
    this.commonService.closePopUp();
  }

  applyCoupon() {
    this.commonService.closingPopupWithSendData("applied_Checkout")
  }
}
